<template>
  <div style="margin: 0 0 12px;">
    <div class="info-list">
      <div class="info-list-item">
        <span class="info-list-item-title">商品种类：</span>
        <span>{{typeSum}}</span>
      </div>
      <div class="info-list-item">
        <span class="info-list-item-title">系统库存总计：</span>
        <span>{{realSum}}</span>
      </div>
      <div class="info-list-item">
        <span class="info-list-item-title">盘点库存总计：</span>
        <span>{{takeSum}}</span>
      </div>
      <div class="info-list-item">
        <span class="info-list-item-title">报损库存总计：</span>
        <span>{{breakageSum}}</span>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {submitAuditStockTake} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pageData: this.value.pageData,
      id: this.value.id,

      typeSum: 0,
      realSum: 0,
      takeSum: 0,
      breakageSum: 0,
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      let param = {}
      param['id'] = this.id
      postFormData(submitAuditStockTake, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
    this.pageData.map(item => {
      this.typeSum += 1
      this.realSum += Number(item.realNum)
      this.takeSum += Number(item.takeNum)
      this.breakageSum += Number(item.breakageNum)
    })
  }
}
</script>

<style scoped>
.info-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ebeef5;
  padding: 24px 0;
}
.info-list-item {
  display: flex;
  align-items: center;
  line-height: 1.8;
}
.info-list-item-title {
  text-align: right;
  margin-right: 8px;
  width: 98px !important;
}
</style>
